import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import Text from '@/components/ui/custom/dataDisplay/Text';
import HackathonStagesPermission from '@/utils/permissions/HackathonStagesPermission';
import { useTranslation } from 'react-i18next';
import ProjectCardProps from './factory/ProjectCardProps';
import HackathonFinalistAction from './HackathonFinalistAction';
import HackathonWinnersAction from './HackathonWinnersAction';

type HackathonActionFactoryProps = ProjectCardProps & {
  permissions: HackathonStagesPermission;
};

export const HackathonClassification = ({
  permissions,
  ...props
}: HackathonActionFactoryProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'projects.view',
  });

  if (permissions.canManageSemifinal() || permissions.canManageFinal())
    return (
      <div className="bg-secondary-content p-2.5 gap-2.5 rounded-lg flex flex-col w-full">
        <Text text={t('classification')} className="text-secondary font-500" />
        <div className="flex gap-2.5">
          <Text text={t('classificationPhrase')} />

          <ConditionalRenderer condition={permissions.canManageFinal()}>
            <HackathonWinnersAction {...props} />
          </ConditionalRenderer>
          <ConditionalRenderer condition={permissions.canManageSemifinal()}>
            <HackathonFinalistAction {...props} />
          </ConditionalRenderer>
        </div>
      </div>
    );

  return null;
};

export default HackathonClassification;
